import punycode from 'punycode/'
import ITld from '@/types/tld.interface'

const getTldByDomain = (tlds: ITld[], domain: string) => {
  const tldRegExp = new RegExp('(\\.[a-zA-Zа-яА-Я.-0-9]+)$')
  const match = domain.match(tldRegExp)
  const name = match ? domain.replace(match[0], '') : domain.replace('.', '')

  const domainTld =
    match && tlds.find((tld) => match && punycode.toUnicode(tld.domain_tld) === match[0].slice(1))
  return { tld: domainTld, name }
}

export default getTldByDomain
